import TabsRenderer from '@/modules/core/components/shared/TabsRenderer/TabsRenderer'

export default TabsRenderer
